import { render, staticRenderFns } from "./BuscaAvancada.vue?vue&type=template&id=0d9ed098"
import script from "./BuscaAvancada.vue?vue&type=script&lang=js"
export * from "./BuscaAvancada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports